import { AGENTS_BY_ID } from '../lib/agents';
import { useAgentStates } from '../hooks/useAgentStates';

interface Props {
  readonly agentId: string;
}

export function AgentDossier({ agentId }: Props) {
  const { states } = useAgentStates();
  const cfg = AGENTS_BY_ID[agentId as keyof typeof AGENTS_BY_ID];

  if (!cfg) {
    return (
      <article className="text-view">
        <nav>
          <a href="/">← Back to station</a>
        </nav>
        <h1>Unknown agent</h1>
        <p>
          No agent registered with id <code>{agentId}</code>.
        </p>
      </article>
    );
  }

  const state = states.find((s) => s.agentId === cfg.id);

  return (
    <article className="text-view">
      <nav aria-label="Primary">
        <a href="/">← Station view</a> · <a href={`/text/agents/${cfg.id}`}>Text view</a>
      </nav>
      <h1>{cfg.label}</h1>
      <p>
        <em>
          {cfg.title} · {cfg.businessUnit}
        </em>
      </p>
      <p>{cfg.dossier}</p>
      {state && (
        <>
          <h2>Live status</h2>
          <p>
            <span
              className={`status-dot status-${state.status}`}
              aria-hidden="true"
            />
            <strong>{state.status}</strong>
            {state.activity ? ` — ${state.activity}` : null}
          </p>
          {state.kpis && (
            <>
              <h3>KPIs</h3>
              <ul>
                {Object.entries(state.kpis).map(([k, v]) => (
                  <li key={k}>
                    <code>{k}</code>: {v.toLocaleString()}
                  </li>
                ))}
              </ul>
            </>
          )}
        </>
      )}
      <h2>Runtime</h2>
      <p>
        Status URL: <code>{cfg.statusUrl}</code>
      </p>
      <p>
        Reports to: <code>{cfg.reportsTo ?? '—'}</code>
      </p>
    </article>
  );
}
